import React from 'react'
import Select, { components } from 'react-select'

const Control = (props) => (
  <components.Control {...props} className="border border-gray-300 px-3 py-1" />
)

const Priority = ({ attribute, state, onChange }) => {
  const { options, name, disabled } = attribute

  return (
    <fieldset className="space-y-1">
      <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
        { name }
      </p>

      <Select
        value={options.find(({ value }) => value == state)}
        onChange={({ value }) => onChange(value)}
        options={options}
        openMenuOnFocus
        isDisabled={disabled}
        components={{
          Control
        }}
        styles={{
          placeholder: (base) => ({ ...base, color: '#9eaebf', fontSize: '1rem' }),
          singleValue: (base) => ({ ...base, color: '#1a202c', fontSize: '1rem' }),
          valueContainer: (base) => ({ ...base, color: '#1a202c', fontSize: '1rem', padding: 0 }),
        }}
        theme={(theme) => ({ ...theme, borderRadius: 0 })}
      />
    </fieldset>
  )
}

export default Priority
